import { createContext } from "@knyt/tasker";
/**
 * @internal scope: package
 */
export const DeferredContentContext = createContext(null);
